"use strict";
/**
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This module exports all __client__ interfaces: Documentalist concepts that are meant to be used at runtime
 * alongside a compiled documentation data file.
 *
 * The `Documentalist` class and its plugins are only available at compile-time, but their interfaces are useful
 * when rendering the data, so they are exposed separately in this module.
 *
 * A few utility functions are also provided, including several type guards for `@tags`.
 */
__exportStar(require("./compiler"), exports);
__exportStar(require("./kss"), exports);
__exportStar(require("./markdown"), exports);
__exportStar(require("./npm"), exports);
__exportStar(require("./plugin"), exports);
__exportStar(require("./tags"), exports);
__exportStar(require("./typescript"), exports);
__exportStar(require("./utils"), exports);
